import type { BaseApiClient } from './BaseApiClient';
import { baseApiClient } from './BaseApiClient';
import type {
  BillingProfileResponse,
  OrbCreditLedgerParams,
  OrbCreditLedgerResponse,
  OrbInvoiceParams,
  OrbInvoiceResponse,
  OrbSubscriptionResponse,
  OrbUsageParams,
  OrbUsageResponse,
  SetupIntentResponse,
  UpdateBillingProfileRequest,
} from './types';

class BillingClient {
  constructor(private apiClient: BaseApiClient) {}

  getSubscriptions = () => {
    return this.apiClient.get<OrbSubscriptionResponse>('/p/v1/billing/subscriptions/');
  };

  getInvoices = (params: OrbInvoiceParams) => {
    return this.apiClient.get<OrbInvoiceResponse>('/p/v1/billing/invoices/', params);
  };

  getUsage = (params: OrbUsageParams) => {
    return this.apiClient.get<OrbUsageResponse>('/p/v1/billing/usage/', params);
  };

  getCreditLedger = (params: OrbCreditLedgerParams) => {
    return this.apiClient.get<OrbCreditLedgerResponse>('/p/v1/billing/credits/ledger/', params);
  };

  getBillingProfile = () => {
    return this.apiClient.get<BillingProfileResponse>('/p/v1/billing/profile/');
  };

  updateBillingProfile = (payload: UpdateBillingProfileRequest) => {
    return this.apiClient.patch<BillingProfileResponse>('/p/v1/billing/profile/', payload);
  };

  setupIntent = () => {
    return this.apiClient.post<SetupIntentResponse>('/p/v1/billing/intents/', {});
  };
}

export const billingClient = new BillingClient(baseApiClient);
